import * as React from "react";
import { CheckPricesProps } from "./typings";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { Experiment, isVariantEnabled } from "src/components/utility/experiment";
import { Container } from "./component/Container";
import { Deal } from "./component/Deal";

const checkPricesKey = new ItemKeyHelper("check-prices");

const defaultKeys = ["bestWeekend", "today", "thisWeekend", "nextWeekend"];
const checkPricesV3Keys = ["today", "tomorrowNight", "thisWeekend", "nextWeekend", "bestWeekend"];

export const viewContext = React.createContext<string>("");
const ViewProvider = viewContext.Provider;

export const CheckPrices = (props: CheckPricesProps) => {
  const { context, flexComponent } = props;
  const isCheckPricesV3Enabled = isVariantEnabled(context, Experiment.Flex_check_prices_version_3);
  const searchContext = context && context.searchContext;
  const model = flexComponent.model;
  const keys = isCheckPricesV3Enabled ? checkPricesV3Keys : defaultKeys;

  const containerProps = {
    title: model.title,
    id: flexComponent.id,
    fmId: flexComponent.fmId,
    fmTitleId: flexComponent.fmTitleId,
    view: model.view
  };

  return (
    <ViewProvider value={model.view}>
      <Container {...containerProps}>
        {keys.map(modelKey => (
          <Deal
            key={checkPricesKey.next()}
            modelKey={modelKey}
            model={model}
            searchContext={searchContext}
          />
        ))}
      </Container>
    </ViewProvider>
  );
};

export default CheckPrices;
